export default {
  white: "#FFF",
  hoveredGray: "#FAFAFA",
  selectedGray: "#EEE",
  defaultGray: "#BBB",
  textGray: "#555"
};
